// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f65007e6","46":"cc87e62c","77":"266cf9c4","81":"edc7771e","112":"84040f3f","169":"305e08c7","278":"72d7cf53","511":"d3cc819f","570":"53abdd90","684":"1d4240c7","726":"225b329d","806":"6e70ec5e","842":"137fb788"}[chunkId] + ".chunk.js";
};